import { SagaIterator } from 'redux-saga';
import { all, fork } from 'redux-saga/effects';
import { listDevBoxAddOnsListenerSaga } from './list-dev-box-add-ons';
import { loadDevBoxAddOnsForDevBoxesListenerSaga } from './load-dev-box-add-ons-for-dev-boxes';

export function* rootSaga(): SagaIterator {
    yield all([fork(listDevBoxAddOnsListenerSaga), fork(loadDevBoxAddOnsForDevBoxesListenerSaga)]);
}
